export default __webpack_public_path__ + "static/media/BuyBackMBP.6ac37d72.svg";